<template>
  <form class="p-2" @submit.prevent="submitDeviceForm">
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">
          {{ isEdit ? $t("edit_device") : $t("assign_device") }}
        </h4>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="form-group w-100">
                  <label>{{ $t("device") }}</label>
                  <select
                    class="form-control"
                    style="height: 50px"
                    name="device"
                    v-model="deviceSettings.device"
                    required
                    @change="handleDeviceChange(deviceSettings.device.id)"
                  >
                    <option
                      v-for="device in devices"
                      :value="{
                        id: device.id,
                        settings: { name: device.settings.name },
                      }"
                      :key="device.id"
                    >
                      {{ device.settings.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label>{{ $t("min-temp") }} (°C) {{ $t("optional") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.number="deviceSettings.minTemperature"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label>{{ $t("max-temp") }} (°C) {{ $t("optional") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.number="deviceSettings.maxTemperature"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label>{{ $t("min-humid") }} (%) {{ $t("optional") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.number="deviceSettings.minHumidity"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label>{{ $t("max-humid") }} (%) {{ $t("optional") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      v-model.number="deviceSettings.maxHumidity"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="selected-devices-list">
                  <div
                    v-for="device in selectedDevicesSettings"
                    :key="device.dataLogger.id"
                    class="selected-device-item d-flex align-items-center col-gap-1"
                  >
                    <div class="selected-device-item__name">
                      {{ device.dataLogger.settings.name }}
                    </div>
                    <div class="selected-device-item__actions">
                      <input
                        type="checkbox"
                        @change="handleSelectedDevice(device.dataLogger.id)"
                        :id="device.dataLogger.id"
                        :checked="selectedDeviceId === device.dataLogger.id"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("add") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </form>
</template>

<script>
import ModalContainer from "../../../components/ModalContainer.vue";
import { mapGetters } from "vuex";

export default {
  name: "DeviceSettingsModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    itemData: Object,
    selectedDevicesSettings: Array,
  },
  data() {
    return {
      deviceSettings: {
        device: {},
        minTemperature: null,
        maxTemperature: null,
        minHumidity: null,
        maxHumidity: null,
      },
      isEdit: false,
      selectedDeviceId: null,
    };
  },
  methods: {
    submitDeviceForm() {
      const payload = {
        dataLogger: this.deviceSettings.device,
        dataLoggerSettings: {
          minTemperature: this.deviceSettings.minTemperature,
          maxTemperature: this.deviceSettings.maxTemperature,
          minHumidity: this.deviceSettings.minHumidity,
          maxHumidity: this.deviceSettings.maxHumidity,
        },
      };
      if (this.isEdit) {
        this.$emit("edit-item", payload);
      } else {
        this.$emit("add-item", payload);
      }
    },
    handleSelectedDevice(id) {
      if (this.selectedDeviceId === id) {
        this.selectedDeviceId = null;
      } else {
        this.selectedDeviceId = id;
      }
    },
    handleDeviceChange(id) {
      // this.deviceSettings.device = event.target.value;
      if (
        this.selectedDevicesSettings.some(
          (device) => device.dataLogger.id === id
        )
      ) {
        this.selectedDeviceId = id;
      } else {
        this.selectedDeviceId = null;
        this.deviceSettings = {
          ...this.deviceSettings,
          maxHumidity: null,
          minHumidity: null,
          maxTemperature: null,
          minTemperature: null,
        };
      }
    },
  },
  watch: {
    itemData: {
      handler(val) {
        if (val?.dataLogger?.id) {
          this.isEdit = true;
          if (
            this.selectedDevicesSettings.some(
              (device) => device.dataLogger.id === val.dataLogger.id
            )
          ) {
            return (this.selectedDeviceId = val.dataLogger.id);
          }

          this.deviceSettings = {
            device: {
              id: val.dataLogger.id,
              settings: {
                name: val.dataLogger.settings.name,
              },
            },
            ...val.dataLoggerSettings,
          };
        }
      },
      deep: true,
      immediate: true,
    },
    selectedDeviceId: {
      handler(val) {
        if (val) {
          console.log(val, "selectedDeviceId");
          const selectedDevice = this.selectedDevicesSettings.find(
            (device) => device.dataLogger.id === val
          );
          const { dataLogger, ...rest } = selectedDevice;

          this.deviceSettings = {
            device: dataLogger,
            ...rest,
          };
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["devices"]),
    availableDevices() {
      return this.devices.filter(
        (device) =>
          !this.selectedDevicesSettings.some(
            (selectedDevice) => selectedDevice.dataLogger.id === device.id
          )
      );
    },
  },
};
</script>
